<template>
  <div class="contact-hero">
    <img class="contact-hero-bg" :src="carousel.image" :alt="carousel.alt" />
    <!-- <div class="contact-hero-title">
      <div>{{ t('contactUs.carousel.title_chi') }}</div>
      <div class="en">{{ t('contactUs.carousel.title_eng') }}</div>
    </div> -->
  </div>
</template>
<script setup>
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
// 从 i18n 获取轮播图配置
const carousel = {
  image: t('contactUs.carousel.image'),
  alt: t('contactUs.carousel.alt'),
}
</script>
<style scoped>
.contact-hero {
  width: 100%;
  /* margin-top: var(--header-height, 80px); */
  position: relative;
  overflow: hidden;
  background: #eaf6ff;
}

.contact-hero-bg {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.contact-hero-title {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  z-index: 2;
  padding-left: 20vw;
}

.contact-hero-title div {
  color: #fff;
  /* 需要适配 */
  font-size: 3rem;
  font-weight: bold;
  text-shadow: 0 2px 16px rgba(0, 0, 0, 0.18);
}

.contact-hero-title .en {
  /* 需要适配 */
  font-size: 3rem;
  font-weight: bold;
  margin-top: 8px;
}

/* 大屏幕设备 (1400px 以上) */
@media screen and (min-width: 1400px) {
  .contact-hero-title div {
    font-size: 3rem;
  }

  .contact-hero-title .en {
    font-size: 3rem;
    margin-top: 8px;
  }
}

/* 笔记本电脑 */
@media screen and (max-width: 1399px) {
  .contact-hero-title div {
    font-size: 2.6rem;
  }

  .contact-hero-title .en {
    font-size: 2.6rem;
    margin-top: 8px;
  }
}

/* 平板设备 */
@media screen and (max-width: 991px) {
  .contact-hero-title div {
    font-size: 2.2rem;
  }

  .contact-hero-title .en {
    font-size: 2.2rem;
    margin-top: 8px;
  }
}

/* 手机设备 */
@media screen and (max-width: 767px) {
  .contact-hero-title div {
    font-size: 1.6rem;
  }

  .contact-hero-title .en {
    font-size:  1.6rem;
    margin-top: 8px;
  }
}
</style>